export function getLocalStorageItem(key: string, defaultValue: unknown) {
  const storedValue = localStorage.getItem(key);
  if (storedValue) {
    try {
      return JSON.parse(storedValue);
    } catch {
      // should be a string, if it's empty string, return null
      return storedValue || null;
    }
  }

  if (defaultValue instanceof Function) {
    return defaultValue();
  }

  return defaultValue;
}

export function setLocalStorageItem(key: string, value: unknown) {
  if (typeof value === 'string') {
    localStorage.setItem(key, value);
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
}

export function removeLocalStorageItem(key: string) {
  localStorage.removeItem(key);
}
